import { render, staticRenderFns } from "./TableColumnsPicker.vue?vue&type=template&id=47987ad8&scoped=true"
import script from "./TableColumnsPicker.vue?vue&type=script&lang=js"
export * from "./TableColumnsPicker.vue?vue&type=script&lang=js"
import style0 from "./TableColumnsPicker.vue?vue&type=style&index=0&id=47987ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47987ad8",
  null
  
)

export default component.exports